import MockAdapter from 'axios-mock-adapter';

/**
 *  导入模拟数据
 * */

// 首页模块
import home from './modules/index';

export default function (axios) {
  const mock = new MockAdapter(axios);
  // 拦截请求
  mock
    .onGet(/_m=get_index_page&_a=home/)
    .reply(200, home)
    .onAny()
    .passThrough();
}
